import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.909 8.407q-.3-.586-.9-.587h-7.9l.9-6.745c.1-.39-.2-.88-.6-.978a.97.97 0 0 0-1.2.294l-10 11.73c-.2.294-.3.685-.1 1.076.2.293.5.49.9.49h7.9l-.9 6.744c-.1.391.2.88.6.978.1.098.3.098.4.098.3 0 .6-.098.8-.392l10-11.73c.2-.294.3-.685.1-.978m-9.5 8.896.6-4.497c0-.293-.1-.586-.2-.782-.2-.196-.5-.293-.8-.293h-6.9l6.4-7.528-.5 4.497c0 .293.1.587.2.782.2.196.5.293.7.293h6.9z"
    }, null, -1)
  ]))]))
}
export default { render: render }